module.exports = __webpack_public_path__ + "static/media/28DGC10.e36838d4.jpg";